const getTotalAmenitiesCount = (totalAmenities: any): number =>
  totalAmenities.reduce((acc: any, { values }: any) => acc + (values?.length || 0), 0);
export default getTotalAmenitiesCount;
